<template>
  <div class="game-card">
    <div class="header">
      <div class="icon">
        <img v-if="gameInfo.game && gameInfo.game.icon" :src="gameInfo.game.icon" :alt="gameInfo.game.name" />
      </div>
      <div class="infos">
        <div class="name">{{ gameInfo.game && gameInfo.game.name }}</div>
        <div class="company">
          <span>厂商:</span>
          <span>{{ gameInfo.ext && gameInfo.ext.developer }}</span>
        </div>
        <div class="des">
          <span v-if="gameInfo.ext && gameInfo.ext.pub_at">{{ gameInfo.ext.pub_at | dateFormat("MM月DD日") }}</span>
          <span> {{ gameInfo.ext && gameInfo.ext.pub_area }}</span>
        </div>
      </div>
    </div>
    <div
      class="game-des"
      v-if="gameInfo.ext && gameInfo.ext.desc"
      :style="{ paddingBottom: isDescOverflow ? '40px' : '16px' }"
    >
      <pre :class="[isExpand ? '' : 'hidden-des']" ref="descContent" v-html="xss(gameInfo.ext.desc)"></pre>
      <div v-if="isDescOverflow && !isExpand" class="hidden-bg"></div>
      <div class="bottom-info" v-if="isDescOverflow">
        <span @click="isExpand = !isExpand">
          {{ isExpand ? "收起" : "展开" }}
          <i v-if="isExpand" class="el-icon-arrow-up"></i>
          <i v-else class="el-icon-arrow-down"></i>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "InfoCard",
  props: {
    gameInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isExpand: false,
      isDescOverflow: false
    };
  },
  mounted() {
    // 检测desc内容是否溢出
    this.checkDescOverflow();
  },
  methods: {
    checkDescOverflow() {
      const contentBox = this.$refs.descContent;
      if (contentBox && contentBox.scrollHeight > contentBox.clientHeight) {
        this.isDescOverflow = true;
      } else {
        this.isDescOverflow = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.game-card {
  width: 100%;
  .header {
    display: flex;
    margin-bottom: 24px;
    .icon {
      width: 80px;
      height: 80px;
      margin-right: 14px;
      border-radius: 4px;
      background-color: #e3e6ee;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
      }
    }
    .infos {
      display: flex;
      flex-direction: column;
      .name {
        margin-bottom: 8px;
        color: 000;
        font-size: 20px;
        font-weight: 600;
      }
      .company {
        margin-bottom: 8px;
        color: #666;
        font-size: 13px;
      }
      .des {
        color: #999;
        font-size: 12px;
      }
    }
  }
  .game-des {
    position: relative;
    padding: 16px;
    background-color: #f8f8f8;
    color: #666;
    font-size: 14px;
    border-radius: 8px;
    .hidden-des {
      max-height: 150px;
      overflow: auto;
    }
    pre {
      word-break: break-word;
      white-space: pre-wrap;
    }
    .hidden-bg {
      position: absolute;
      bottom: 40px;
      left: 0;
      width: 100%;
      height: 56px;
      background: linear-gradient(180deg, rgba(248, 248, 248, 0) 0%, #f8f8f8 100%);
    }
    .bottom-info {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      color: #00afe8;
      font-size: 12px;
      span {
        cursor: pointer;
      }
    }
  }
}
</style>
